export default {
  loginInfo: {
    corpCode: '',
    userName: '',
    password: '',
    userType: '',
    token: ''
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js